import { createSlice } from '@reduxjs/toolkit';

const agentsSlice = createSlice({
  name: 'agents',
  initialState: [],
  reducers: {
    setAgents: (state, action) => {
      return action.payload;
    },
  },
});

export const { setAgents } = agentsSlice.actions;
export default agentsSlice.reducer;
